var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconStar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.122,
    height: 12.83,
    viewBox: "0 0 14.122 12.83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M616.5,597.333l1.966,3.8a.278.278,0,0,0,.21.146l4.4.609a.263.263,0,0,1,.154.454l-3.18,2.955a.259.259,0,0,0-.08.235l.751,4.174a.277.277,0,0,1-.405.28l-3.931-1.97a.291.291,0,0,0-.26,0l-3.931,1.97a.277.277,0,0,1-.405-.28l.751-4.174a.258.258,0,0,0-.08-.235l-3.18-2.955a.263.263,0,0,1,.154-.454l4.4-.609a.278.278,0,0,0,.21-.146l1.966-3.8A.286.286,0,0,1,616.5,597.333Z",
    transform: "translate(-609.194 -597.185)",
    fill: "#ffca0e"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_star.c2082785.svg";
export { ForwardRef as ReactComponent };